// extracted by mini-css-extract-plugin
export default {"wrapper":"PromoCodePills-rebranding-module__wrapper___ETZbr","pill":"PromoCodePills-rebranding-module__pill___i4d_w","text":"PromoCodePills-rebranding-module__text___2YJlK"};